import { MonitorAlertFullDto } from "@/app/Alert/types";
import { Dialog, DialogContent, DialogHeader } from "@/components/ui/dialog";
import { useState } from "react";
import { CroppedImage } from "@/components/offenders/CroppedImage";
import { Offender } from "@/components/offenders/types";

interface AdminOffenderCardProps {
  offender?: Partial<Offender>;
  offenderID?: string;
  alertData?: MonitorAlertFullDto;
  onEdit?: (id: string) => void;
}

export function AdminOffenderCard({
  offender,
  offenderID,
  alertData,
  onEdit,
}: AdminOffenderCardProps) {
  const imageConfig = offender?.images?.[0];
  const [isImageOpen, setIsImageOpen] = useState(false);

  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-[#2E3835] bg-card2 text-white">
      <div
        onClick={() => setIsImageOpen(true)}
        className="  flex-shrink-0 cursor-pointer transition-opacity hover:opacity-80"
      >
        {offender?.images && offender.images[0] && (
          <CroppedImage
            alertData={alertData}
            coordinates={offender.images[0]}
            className="h-full w-full object-contain max-h-[20rem] border-b"
          />
        )}
      </div>

      <div className="flex flex-1 flex-col flex-wrap space-y-2 p-4">
        {onEdit && <h2 className="font-semibold text-lime">Offender #{offenderID}</h2>}

        <div className="grid grid-cols-2 gap-4 text-sm">
        {offender?.sex && (
            <p>
              <span className="text-gray-400">Gender:</span><br/> {offender?.sex}
            </p>
          )}
               {offender?.age && (
            <p>
              <span className="text-gray-400">Age:</span><br/> {offender?.age}
            </p>
          )}
             {offender?.build && (
            <p>
              <span className="text-gray-400">Build:</span><br/> {offender?.build}
            </p>
          )}
        
          {offender?.height && (
            <p>
              <span className="text-gray-400">Height:</span><br/> {offender?.height}
            </p>
          )}
       
          {offender?.ethnicity && (
            <p>
              <span className="text-gray-400">Ethnicity:</span><br/> {offender?.ethnicity}
            </p>
          )}
     
          {offender?.hair && (
            <p>
              <span className="text-gray-400">Hair:</span><br/> {offender?.hair}
            </p>
          )}
          {offender?.clothingTop && (
            <p>
              <span className="text-gray-400">Clothing Top:</span><br/> {offender?.clothingTop}
            </p>
          )}
          {offender?.clothingPants && (
            <p>
              <span className="text-gray-400">Clothing Pants:</span><br/> {offender?.clothingPants}
            </p>
          )}
          {offender?.clothingShoes && (
            <p>
              <span className="text-gray-400">Clothing Shoes:</span><br/> {offender?.clothingShoes}
            </p>
          )}
          {offender?.clothing && (
            <p>
              <span className="text-gray-400">Clothing Other:</span><br/> {offender?.clothing}
            </p>
          )}
          {offender?.distinguishingFeatures && (
            <p>
              <span className="text-gray-400">Distinguishing Features:</span><br/> {offender?.distinguishingFeatures}
            </p>
          )}
          {offender?.description && (
            <p className="col-span-2 border-t pt-4">
              <span className="text-gray-400">Description:</span><br/>   {offender?.description}
            </p>
          )}
          {offender?.otherInfo && (
            <p className="col-span-2">
              <span className="text-gray-400">Notes:</span> {offender?.otherInfo}
            </p>
          )}
        </div>
      </div>

      <Dialog open={isImageOpen} onOpenChange={setIsImageOpen}>
        <DialogContent>
          <DialogHeader>Offender #{offenderID}</DialogHeader>
          <CroppedImage
            alertData={alertData}
            coordinates={imageConfig}
            className="h-full w-full max-h-[50vh] max-w-[50vw] object-contain"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
